<script setup>
</script>

<template>
  <slot></slot>
</template>

<style lang="scss" scoped>
</style>
